const React = require("react");

function SelectorIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8 9l4-4 4 4m0 6l-4 4-4-4"
  }));
}

module.exports = SelectorIcon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@heroicons/react/outline/SelectorIcon.js
 ** module id = 606
 ** module chunks = 0
 **/